module.exports = __webpack_public_path__ + "img/ltLogo.bc2ac449.svg";